<zimmerer-route-ion-wrapper class="ion-page">

  <!-- TODO try to remove and use observable -->
  <!-- [class.noSlider]="!hasImageSliderItems()" -->
  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col withBottomPadding" [class.withTopPadding]="MobileService.isMobile"
      [class.noSlider]="!hasSliderImages" fxLayout="column" fxLayoutGap="20px">

      <div fxHide.gt-md fxLayout="column" fxLayoutGap="5px">
        <div style="text-align: center;">Marktplatz</div>
        <h2 class="listHeadline">Dein Marktplatz für Zimmereibedarf.<br>Jetzt kaufen und verkaufen!</h2>
      </div>

      <image-slider [fxHide]="!hasSliderImages" [page]="'advert'" fxHide.lt-lg></image-slider>

      <app-searchbar (onSearch)="changeFilter($event.filter,'string',$event.value)"
        (onPreflightSearch)="onPreflightSearch($event)" [preflightValues]="preflightValues"
        entityTypeIdentifier="advert">
      </app-searchbar>

      <!-- MOBILE only - local create button -->
      <button fxHide.gt-md class="orange-button create-btn" (click)="StateService.goto('/market/create',{},true,true)">
        Beitrag erstellen
      </button>

      <!-- show filter toggle button - only mobile -->
      <div fxHide.gt-md>
        <button class="mobileGrowBtn unselectable" (click)="changeFilter('filtersopen','boolean')">
          {{ StateService.queryParams['filtersopen'] ? 'Kategorieauswahl schließen' : 'Kategorie auswählen' }}
        </button>
      </div>

      <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="20px">

        <!-- param filters -->
        <div *ngIf="MobileService.isDesktop || StateService.queryParams['filtersopen']" fxLayout="column"
          fxLayoutGap="20px" fxFlex="25" class="sidebar-wrapper">

          <div class="categoryFilterHeadline">Kategorie</div>

          <app-category-selection [inputCategories]="{
            type: CategoryType.marketplace,
            selected: StateService.queryParams.marketplace_category_id != null ? StateService.queryParams.marketplace_category_id : null
          }" (onCategorySelect)="changeFilter($event.filter,'boolean',$event.value)" [withReset]="true">
          </app-category-selection>

          <div fxLayout="column" fxLayoutGap="20px">

            <div fxLayout="column" fxLayoutGap="10px">
              <div class="filter-header">
                Anzeigenart
              </div>
              <div fxLayout="row">
                <mat-checkbox color="primary" [checked]="StateService.queryParams.offer=='true'"
                  (change)="changeFilter('offer','boolean')">
                  Angebot
                </mat-checkbox>
              </div>
              <div fxLayout="row">
                <mat-checkbox color="primary" [checked]="StateService.queryParams.search=='true'"
                  (change)="changeFilter('search','boolean')">
                  Suche
                </mat-checkbox>
              </div>
            </div>

            <div fxLayout="column" fxLayoutGap="10px">
              <div class="filter-header">
                Gebrauchszustand
              </div>
              <div fxLayout="row">
                <mat-checkbox color="primary" [checked]="StateService.queryParams.new=='true'"
                  (change)="changeFilter('new','boolean')">
                  Neu
                </mat-checkbox>
              </div>
              <div fxLayout="row">
                <mat-checkbox color="primary" [checked]="StateService.queryParams.used=='true'"
                  (change)="changeFilter('used','boolean')">
                  Gebraucht
                </mat-checkbox>
              </div>
            </div>

            <!-- <div fxLayout="column" fxLayoutGap="10px">
            <div class="filter-header">
              Standort
            </div>
            <div>
              <input matInput [(ngModel)]="stateParams.zip_city" type="text" (change)="applyFilterZIPCity('zip_city')" placeholder="PLZ/Ort">
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <div fxFlex="30">Umkreis</div>

              <div fxFlex="70" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-form-field style="display: block;" fxFlex="grow">
                  <mat-select matInput class="unselectable" (selectionChange)="applyFilter('radius_search_km')"
                  [(ngModel)]="stateParams.radius_search_km" [disabled]="!stateParams.zip_city">
                    <mat-option value="50">50 km</mat-option>
                    <mat-option value="100">100 km</mat-option>
                    <mat-option value="250">250 km</mat-option>
                    <mat-option value="500">500 km</mat-option>
                  </mat-select>
                </mat-form-field>

                <small-round-btn *ngIf="stateParams.radius_search_km" icon="fa fa-times" [click]="deleteRadiusSearchFilter.bind(this)" [tiny]="true" fxFlex="noshrink"></small-round-btn>

              </div>
            </div>
          </div> -->

            <!-- <div fxLayout="column" fxLayoutGap="10px">
            <div class="filter-header">
              Preis
            </div>
            <div fxLayout="row" fxLayoutGap="10px">

              <div fxFlex="50">
                <input matInput placeholder="von"
                type="text"
                [(ngModel)]="stateParams.price_from"
                (change)="changeFilterPrice('price_from')">
              </div>

              <div fxFlex="50">
                <input matInput placeholder="bis"
                type="text"
                [(ngModel)]="stateParams.price_to"
                (change)="changeFilterPrice('price_to')">
              </div>
            </div>
          </div> -->
          </div>
        </div>

        <!-- advert grid -->
        <div *ngIf="pagination && pagination.values; else noHits;" fxLayout="column" fxFlex="grow" fxFlex.gt-md="75"
          class="marketplace_maincol">

          <div *ngIf="!LoadingService.isLoading && pagination.values.length<1" fxLayout="column" fxLayoutGap="10px">
            <div>leider kein Ergebnis mit den von dir eingestellten Filtern gefunden.</div>
            <div>Sei der Erste!</div>
            <button class="orange-button create-btn" style="max-width: 230px;"
              (click)="StateService.goto('/market/create',{},true,true)">
              Beitrag erstellen
            </button>
          </div>

          <div class="advert-grid">

            <advert-grid-item *ngFor="let advert of pagination.values" #impressionAnchor [entity]="advert"
              data-entitytype="Advert" data-id="{{advert.id}}">
            </advert-grid-item>

          </div>

        </div>
        <ng-template #noHits>
          <b>{{!LoadingService.isLoading ? 'Für deine Suche / Filter gibt es leider keine Treffer.' : ''}}</b>
        </ng-template>

      </div>

      <app-pagination [pagination]="pagination" [stateParams]="StateService.queryParams"
        (onGotoPage)="changeFilter($event.filter,'number',$event.value)">
      </app-pagination>

    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>